import { Injectable } from '@angular/core';
import { AppVariables, StorageService } from '@shared';
import { RxdbIdProvider } from './rxdb-id.provider';

@Injectable()
export class RefTablesStorageService {
	public constructor(
		private storageService: StorageService,
		private rxdbIdProvider: RxdbIdProvider
	) {}

	public async set<T>(workfileId: string, key: string, value: T): Promise<void> {
		await this.storageService.set(`${workfileId}${AppVariables.INTERNAL_STORAGE_REF_TABLE_PREFIX}${key}`, value);
	}

	public async get<T>(workfileId: string, key: string): Promise<T> {
		return await this.storageService.get(`${workfileId}${AppVariables.INTERNAL_STORAGE_REF_TABLE_PREFIX}${key}`);
	}

	public async getKeys(workfileId: string): Promise<string[]> {
		const recordsKeys: string[] = await this.storageService.keys();

		return recordsKeys.filter((key: string) =>
			key.startsWith(`${workfileId}${AppVariables.INTERNAL_STORAGE_REF_TABLE_PREFIX}`)
		);
	}

	public async deleteRecords(workfileId: string): Promise<void> {
		const recordsKeys: string[] = await this.getKeys(workfileId);

		// partially deleted workfile
		// make sure there are still records to be deleted and avoid triggering an error
		if (recordsKeys.length === 0) {
			return;
		}

		const records: void[] = await Promise.all(recordsKeys.map((k: string) => this.storageService.remove(k)));

		if (records.length === 0) {
			throw new Error('Delete workfile (ref tables) failed');
		}
	}

	public async deleteLastRxdbIdRecord(workfileId: string): Promise<void> {
		await this.storageService.remove(this.rxdbIdProvider.buildKey(workfileId));
	}
}
